'use client';
import Link from 'next/link';
import Image from 'next/image';
import { FaRegCirclePlay } from 'react-icons/fa6';
import { useState } from 'react';
import VideoModal from '../videoModal/videoModal';

interface WhyExistVideoProps {
  videoUrl: string;
  imageSrc: string;
  blurDataURL: string;
}
export default function WhyExistVideo({
  videoUrl,
  imageSrc,
  blurDataURL,
}: WhyExistVideoProps) {
  const [modalShow, setModalShow] = useState(false);
  return (
    <div className="videoWrap">
      <Link
        href="#"
        role="button"
        aria-label="Play video"
        onClick={(e) => {
          e.preventDefault();
          setModalShow(true);
        }}
      >
        <Image
          src={imageSrc}
          alt="Thumbnail image for video"
          sizes="(max-width: 767px) 100vw, 70vw"
          width={700}
          height={500}
          placeholder="blur"
          blurDataURL={blurDataURL}
        />
        <span
          className="playIcon"
          style={{ fontSize: '88px' }}
          aria-hidden="true"
        >
          <FaRegCirclePlay />
        </span>
      </Link>
      <VideoModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        videoUrl={videoUrl}
      />
    </div>
  );
}
